<template>
  <Popup :modelValue="modelValue" popupHeader="Why can't I submit my reimbursement now?">
    <p class="text-body text-grey-body">
      You will be able to submit for reimbursement on Bright Horizons Back-Up Care after the last care session date on a
      reservation.
    </p>
    <p class="text-body text-grey-body mt-20">
      Your caregiver must also log into Sittercity and confirm that the bookings took place.
    </p>
    <Button class="w-full mt-16" value="Ok" @click="$emit('close')" />
  </Popup>
</template>

<script lang="ts">
import Popup from '@/components/popup/Popup.vue';
import Button from '@/components/button/Button.vue';

export default {
  components: {
    Popup,
    Button,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
